import styles from "@/interface/RightSheet/Presentations/AddFirstPresentation/AddFirstPresentation.module.scss";

type AddFirstSlideItemProps = {
    src: string;
    text: string;
};
export const AddFirstPresentationItem = ({ src, text }: AddFirstSlideItemProps) => {
    return (
        <div className={styles.AddFirstSlideItem}>
            <img src={src} alt={text} />
            <p>{text}</p>
        </div>
    );
};
